define('helpers',
[], function() {

    var helpers = {
        
        /*
         * Format a number with the number of decimals and thousands separators.
         */
        formatNumber: function(number, decimals, decimalPoint, thousandsSeperator) {
            decimalPoint = decimalPoint || '.';
            thousandsSeperator = thousandsSeperator || '';

            var number = !isFinite(+number) ? 0 : +number, 
                precision = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                toFixedFix = function (number, precision) {
                    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                    var k = Math.pow(10, precision);
                    return Math.round(number * k) / k;
                },
                s = (precision ? toFixedFix(number, precision) : Math.round(number)).toString().split('.');

            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandsSeperator);
            }
/*
            if ((s[1] || '').length < precision) {
                s[1] = s[1] || '';
                s[1] += new Array(precision - s[1].length + 1).join('0');
            }
*/
            return s.join(decimalPoint);
        },

        /*
         * Get the name of the month from a date object.
         */
        getDayNameFromDate: function(date) {
            return helpers.days[date.getDay()];
        },

        addOrdinalSuffix: function(number) {
            var j = number % 10,
                k = number % 100;
            if (j == 1 && k != 11) {
                return number + "st";
            }
            if (j == 2 && k != 12) {
                return number + "nd";
            }
            if (j == 3 && k != 13) {
                return number + "rd";
            }
            return number + "th";
        },

        getOrdinalDayFromDate: function(date) {
            return helpers.addOrdinalSuffix(date.getDate());
        },

        /*
         * Get the name of the month from a date object.
         */
        getMonthNameFromDate: function(date) {
            return helpers.months[date.getMonth()];
        },

        /*
         * List of days.
         */
        days: new Array(
            'Sunday', 'Monday', 'Tuesday', 'Wednesday', 
            'Thursday', 'Friday', 'Saturday'
        ),

        /*
         * List of months.
         */
        months: new Array(
            "January", "February", "March", 
            "April", "May", "June", "July", 
            "August", "September", "October", 
            "November", "December"
        )
    };

    return helpers;
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/helpers.js